import { Center, Divider } from '@chakra-ui/react'
import React from 'react'

export const Pipe = () => (
  <Center height="1.5rem">
    <Divider orientation="vertical" opacity="1" margin="0 0.5rem" />
  </Center>
)
